import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Box } from '@mui/material';
import { formatPercent, CustomTooltip, CustomizedLabel } from './staffingRateHelpers';
import { FteRateChart } from 'domain/shared/staffing';
import { Alert } from 'framework/ui/mui-builder';

const StaffingRateChart = ({ data = [], isExpanded = false }: { data: FteRateChart[]; isExpanded?: boolean }) => {
  if (!data?.length) {
    return <Alert color="info">No data</Alert>;
  }

  return (
    <Box sx={{ height: 400 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={isExpanded ? data : data.slice(-12)}
          margin={{
            top: 25,
            bottom: 10,
            right: 7,
          }}
        >
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis
            dataKey="startDate"
            angle={-45}
            textAnchor="end"
            height={80}
            padding={{ left: 5, right: 5 }}
            tick={{ fontSize: 12 }}
            label={{
              value: isExpanded ? 'Date' : 'Date (last 12 months)',
              position: 'insideBottom',
              offset: 10,
              style: { textAnchor: 'middle' },
            }}
          />
          <YAxis
            domain={[0, 100]}
            tickFormatter={formatPercent}
            tick={{ fontSize: 12 }}
            label={{
              value: 'Staffing Rate (%)',
              angle: -90,
              offset: 10,
              position: 'insideLeft',
              style: { textAnchor: 'middle' },
            }}
          />
          <Tooltip content={<CustomTooltip />} />

          <Line
            type="monotone"
            dataKey="staffingRate"
            name="Staffing Rate"
            stroke="var(--mui-palette-warning-main)"
            strokeWidth={3}
            dot={{ fill: 'var(--mui-palette-warning-main)', strokeWidth: 2, r: 4 }}
            label={CustomizedLabel}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StaffingRateChart;
